import type { FC } from "react";
import { NavLink } from "react-router-dom";

import { AppStrings } from "../../utils/constants/AppStrings";
import {
  REGULATOR_PORTAL_DASHBOARD_ROUTE,
  REGULATOR_PORTAL_REPORTS_ROUTE,
  REGULATOR_PORTAL_RESULTS_ROUTE,
  REGULATOR_PORTAL_RULES_ROUTE,
  REGULATOR_PORTAL_SERVICES_ROUTE,
} from "./regulatorPortalRoutes";

import styles from "./RegulatorPortalNav.module.css";

const NAV_ITEMS = [
  {
    to: REGULATOR_PORTAL_DASHBOARD_ROUTE,
    label: AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_TITLE,
    testId: "regulator-portal-nav-overview",
    end: true,
  },
  {
    to: REGULATOR_PORTAL_RESULTS_ROUTE,
    label: AppStrings.PAM_REGULATOR_PORTAL_RESULTS,
    testId: "regulator-portal-nav-results",
    end: false,
  },
  {
    to: REGULATOR_PORTAL_RULES_ROUTE,
    label: AppStrings.PAM_REGULATOR_PORTAL_RULES,
    testId: "regulator-portal-nav-rules",
    end: false,
  },
  {
    to: REGULATOR_PORTAL_SERVICES_ROUTE,
    label: AppStrings.PAM_REGULATOR_PORTAL_SERVICES,
    testId: "regulator-portal-nav-services",
    end: false,
  },
  {
    to: REGULATOR_PORTAL_REPORTS_ROUTE,
    label: AppStrings.PAM_REGULATOR_PORTAL_REPORTS,
    testId: "regulator-portal-nav-reports",
    end: false,
  },
] as const;

const RegulatorPortalNav: FC = () => (
  <nav className={styles.nav} aria-label={AppStrings.PAM_REGULATOR_PORTAL_NAV}>
    {NAV_ITEMS.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.end}
        data-testid={item.testId}
        className={({ isActive }) =>
          `${styles.link}${isActive ? ` ${styles.linkActive}` : ""}`
        }
      >
        {item.label}
      </NavLink>
    ))}
  </nav>
);

export default RegulatorPortalNav;
